<template>
    <section>
        <Hero/>
        <Steps/>
        <News/>
    </section>
</template>

<script setup>
import Hero from "@/views/HomeComponents/Hero";
import Steps from "@/views/HomeComponents/Steps";
import News from "@/views/HomeComponents/News";
</script>
